import { useChatColors } from '@/contexts/ChatColorsContext';

export default function TypingIndicator() {
  const { primary } = useChatColors();

  return (
    <div className="flex items-end gap-2 mb-3">
      <div
        className="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 shadow-sm"
        style={{ background: `linear-gradient(135deg, ${primary}cc, ${primary})` }}
      >
        <span className="text-white font-bold text-xs">B</span>
      </div>
      <div className="bg-white rounded-2xl rounded-bl-sm px-4 py-3 shadow-sm border border-gray-100">
        <div className="flex items-center gap-1">
          {[0, 150, 300].map((delay) => (
            <span
              key={delay}
              className="w-2 h-2 rounded-full animate-bounce"
              style={{ backgroundColor: primary, animationDelay: `${delay}ms` }}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
